import React, { useEffect, useState } from 'react';
import { firestore } from '../config/firebaseConfig';
import { collection, deleteDoc, doc, getDocs, updateDoc, writeBatch, query, where } from 'firebase/firestore';
import './QuestaoList.css'; 
import { MdDeleteForever, MdEditNote } from 'react-icons/md';
import { FaCircle, FaRegStar, FaStar } from "react-icons/fa"; 
import { IoIosArrowRoundUp, IoIosArrowRoundDown } from "react-icons/io";
import { BsFillRocketTakeoffFill } from "react-icons/bs";
import Simulador from '../components/Simulador';
import Modal from 'react-modal';
import { CursosDoItem, FiltroCurso, filtrarPorCurso, useCursosDoConteudo } from '../components/conteudo/CursosDoConteudo';
import { semAcento } from '../components/relatorios/util';

const POR_PAGINA = 20;

function QuestaoList({ onEdit, onDelete, busca = '' }) {
  const [error, setError] = useState('');
  const [temasMap, setTemasMap] = useState({});
  const [questoes, setQuestoes] = useState([]);
  const [sortedQuestoes, setSortedQuestoes] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [selectedTema, setSelectedTema] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [showBloqueadas, setShowBloqueadas] = useState(false);
  const [showPesquisas, setShowPesquisas] = useState(false); // <-- NOVO ESTADO
  const [showSimulador, setShowSimulador] = useState(false);

  const tenantId = localStorage.getItem('tenantId') || 'unknownTenant'; // Obtendo tenantId do localStorage
  const { minicursos, etapasPorConteudo } = useCursosDoConteudo(tenantId);
  const [selectedCurso, setSelectedCurso] = useState('');
  const [pagina, setPagina] = useState(1);

  const showAlert = (message) => {
    alert(message);
  };

  // Calculando o valor máximo de prioridade
  const maxPriority = questoes.reduce((max, q) => (q.prioridade > max ? q.prioridade : max), 0);

  useEffect(() => {
    const fetchTemas = async () => {
      try {
        const temasCollection = query(collection(firestore, 'temas'), where('tenantId', '==', tenantId));
        const questoesCollection = query(collection(firestore, 'questoes'), where('tenantId', '==', tenantId));

        const temasSnapshot = await getDocs(temasCollection);
        const questoesSnapshot = await getDocs(questoesCollection);
        
        const questoesData = questoesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        const temasComQuestoes = temasSnapshot.docs.reduce((acc, temaDoc) => {
          const temaId = temaDoc.id;
          const temaNome = temaDoc.data().nome;
  
          const temQuestoesRelacionadas = questoesData.some(questao => 
            questao.temas && questao.temas.includes(temaId)
          );
          
          if (temQuestoesRelacionadas) {
            acc[temaId] = temaNome;
          }
  
          return acc;
        }, {});
  
        setTemasMap(temasComQuestoes);
      } catch (error) {
        console.error('Erro ao buscar temas ou questões:', error);
        setError('Houve um problema ao buscar os temas.');
      }
    };
  
    fetchTemas();
  }, [tenantId]);  // Adicionamos tenantId como dependência para refazer a busca sempre que ele mudar

  useEffect(() => {
    const fetchQuestoes = async () => {
      try {
        const questoesCollection = query(collection(firestore, 'questoes'), where('tenantId', '==', tenantId));
        const questoesSnapshot = await getDocs(questoesCollection);
        const questoesData = questoesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          prioridade: doc.data().prioridade !== undefined ? Number(doc.data().prioridade) : 0,
        }));
        setQuestoes(questoesData);
      } catch (error) {
        console.error('Erro ao buscar questões:', error);
        setError('Houve um problema ao buscar as questões.');
      }
    };

    fetchQuestoes();
  }, [tenantId]);  // Adicionamos tenantId como dependência

  useEffect(() => {
    let sortableItems = [...questoes];

    if (selectedTema) {
      sortableItems = sortableItems.filter(questao =>
        questao.temas && questao.temas.includes(selectedTema)
      );
    }
    if (showBloqueadas) {
      sortableItems = sortableItems.filter(questao => questao.bloqueado);
    }
    // =================================================================
    //          *** NOVA LÓGICA DE FILTRO PARA PESQUISAS ***
    // =================================================================
    if (showPesquisas) {
        sortableItems = sortableItems.filter(questao => questao.type?.startsWith('pesquisa'));
    }
    if (busca.trim()) {
      const termo = semAcento(busca.trim());
      sortableItems = sortableItems.filter(q => semAcento(q.enunciado).includes(termo) || q.id.includes(busca.trim()));
    }


    const compareItems = (a, b) => {
      if (a.prioridade > 0 && b.prioridade === 0) {
        return -1;
      }
      if (a.prioridade === 0 && b.prioridade > 0) {
        return 1;
      }

      if (a.prioridade > 0 && b.prioridade > 0) {
        if (a.prioridade < b.prioridade) {
          return -1;
        }
        if (a.prioridade > b.prioridade) {
          return 1;
        }
      }

      if (sortConfig && sortConfig.key && sortConfig.key !== 'prioridade') {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        if (sortConfig.key === 'createdAt' || sortConfig.key === 'dataexpiracao') {
          aValue = aValue ? new Date(aValue.seconds * 1000) : new Date(0);
          bValue = bValue ? new Date(bValue.seconds * 1000) : new Date(0);
        }

        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return sortConfig.direction === 'asc'
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        }

        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
      }

      if (a.createdAt && b.createdAt) {
        const dateA = new Date(a.createdAt.seconds * 1000);
        const dateB = new Date(b.createdAt.seconds * 1000);
        return dateA - dateB;
      }

      return 0;
    };

    sortableItems.sort(compareItems);

    // Curso escolhido: só as questões dele, na ordem das etapas (salvo se o usuário ordenar por coluna)
    if (selectedCurso) {
      const doCurso = filtrarPorCurso(sortableItems, selectedCurso, etapasPorConteudo);
      sortableItems = sortConfig.key ? sortableItems.filter((q) => doCurso.includes(q)) : doCurso;
    }

    setSortedQuestoes(sortableItems);
  }, [questoes, sortConfig, selectedTema, showBloqueadas, showPesquisas, selectedCurso, etapasPorConteudo, busca]);

  // filtro ou busca novos voltam para a primeira página
  useEffect(() => { setPagina(1); }, [busca, selectedCurso, selectedTema, showBloqueadas, showPesquisas]);

  const totalPaginas = Math.max(1, Math.ceil(sortedQuestoes.length / POR_PAGINA));
  const questoesDaPagina = sortedQuestoes.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);

  const handleDeleteClick = (id) => {
    setSelectedQuestionId(id);
    setShowConfirmModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteDoc(doc(firestore, 'questoes', selectedQuestionId));
      setQuestoes(prevQuestoes => prevQuestoes.filter(q => q.id !== selectedQuestionId));
      setShowConfirmModal(false);
    } catch (error) {
      console.error('Erro ao excluir questão:', error);
      setError('Houve um problema ao excluir a questão.');
      setShowConfirmModal(false);
    }
  };

  const handleCancelDelete = () => {
    setSelectedQuestionId(null);
    setShowConfirmModal(false);
  };

  const handleToggleBloqueado = async (id, currentStatus, dataexpiracao) => {
    try {
      const isExpired = dataexpiracao && new Date(dataexpiracao + 'T23:59:59Z') < new Date();
      if (currentStatus && !isExpired) {
        const questaoRef = doc(firestore, 'questoes', id);
        await updateDoc(questaoRef, { bloqueado: !currentStatus });
        setQuestoes(prevQuestoes =>
          prevQuestoes.map(questao =>
            questao.id === id ? { ...questao, bloqueado: !currentStatus } : questao
          )
        );
      } else if (!currentStatus) {
        const questaoRef = doc(firestore, 'questoes', id);
        await updateDoc(questaoRef, { bloqueado: !currentStatus });
        setQuestoes(prevQuestoes =>
          prevQuestoes.map(questao =>
            questao.id === id ? { ...questao, bloqueado: !currentStatus } : questao
          )
        );
      } else {
        console.log('A questão não pode ser desbloqueada porque está expirada.');
      }
    } catch (error) {
      console.error('Erro ao atualizar o status da questão:', error);
      setError('Houve um problema ao atualizar o status da questão.');
    }
  };

  const handleTogglePriority = async (questao) => {
    try {
      if (questao.prioridade > 0) {
        await updateDoc(doc(firestore, 'questoes', questao.id), { prioridade: 0 });
        setQuestoes(prevQuestoes =>
          prevQuestoes.map(q =>
            q.id === questao.id ? { ...q, prioridade: 0 } : q
          )
        );
      } else {
        const maxPriority = questoes.reduce((max, q) => (q.prioridade > max ? q.prioridade : max), 0);
        const newPriority = maxPriority + 1;
        await updateDoc(doc(firestore, 'questoes', questao.id), { prioridade: newPriority });
        setQuestoes(prevQuestoes =>
          prevQuestoes.map(q =>
            q.id === questao.id ? { ...q, prioridade: newPriority } : q
          )
        );
      }
    } catch (error) {
      console.error('Erro ao atualizar prioridade:', error);
      setError('Houve um problema ao atualizar a prioridade.');
    }
  };

  const handleMovePriorityUp = async (questao) => {
    try {
      if (questao.prioridade > 1) {
        const novaPrioridade = questao.prioridade - 1;

        const questaoAcima = questoes.find(q => q.prioridade === novaPrioridade);

        if (!questaoAcima) {
          showAlert('Não há uma questão acima para trocar a prioridade.');
          return;
        }

        const batch = writeBatch(firestore);

        const questaoRef = doc(firestore, 'questoes', questao.id);
        batch.update(questaoRef, { prioridade: novaPrioridade });

        const questaoAcimaRef = doc(firestore, 'questoes', questaoAcima.id);
        batch.update(questaoAcimaRef, { prioridade: questaoAcima.prioridade + 1 });

        await batch.commit();

        setQuestoes(prevQuestoes =>
          prevQuestoes.map(q => {
            if (q.id === questao.id) {
              return { ...q, prioridade: novaPrioridade };
            } else if (q.id === questaoAcima.id) {
              return { ...q, prioridade: q.prioridade + 1 };
            }
            return q;
          })
        );
      } else {
        showAlert('A questão já está na prioridade mais alta.');
      }
    } catch (error) {
      console.error('Erro ao mover prioridade para cima:', error);
      setError('Houve um problema ao mover a prioridade para cima.');
    }
  };

  const handleMovePriorityDown = async (questao) => {
    try {
      if (questao.prioridade < maxPriority) {
        const novaPrioridade = questao.prioridade + 1;

        const questaoAbaixo = questoes.find(q => q.prioridade === novaPrioridade);

        if (!questaoAbaixo) {
          showAlert('Não há uma questão abaixo para trocar a prioridade.');
          return;
        }

        const batch = writeBatch(firestore);

        const questaoRef = doc(firestore, 'questoes', questao.id);
        batch.update(questaoRef, { prioridade: novaPrioridade });

        const questaoAbaixoRef = doc(firestore, 'questoes', questaoAbaixo.id);
        batch.update(questaoAbaixoRef, { prioridade: questaoAbaixo.prioridade - 1 });

        await batch.commit();

        setQuestoes(prevQuestoes =>
          prevQuestoes.map(q => {
            if (q.id === questao.id) {
              return { ...q, prioridade: novaPrioridade };
            } else if (q.id === questaoAbaixo.id) {
              return { ...q, prioridade: q.prioridade - 1 };
            }
            return q;
          })
        );
      } else {
        showAlert('A questão já está na prioridade mais baixa.');
      }
    } catch (error) {
      console.error('Erro ao mover prioridade para baixo:', error);
      setError('Houve um problema ao mover a prioridade para baixo.');
    }
  };

  const requestSort = (key) => {
    if (key === 'prioridade') return;
    let direction = 'asc';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? 'sort-icon asc' : 'sort-icon desc';
    }
    return 'sort-icon';
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return '';

    let date;
    if (typeof dateValue.toDate === 'function') {
      date = dateValue.toDate();
    } else if (typeof dateValue === 'string' && !isNaN(Date.parse(dateValue))) {
      date = new Date(dateValue);
    } else if (typeof dateValue === 'object' && dateValue instanceof Date) {
      date = dateValue;
    } else if (typeof dateValue.seconds === 'number') {
      date = new Date(dateValue.seconds * 1000);
    } else {
      return 'Data inválida';
    }

    return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  const isExpired = (dataexpiracao) => {
    if (!dataexpiracao) return false;
    const expirationDate = new Date(dataexpiracao + 'T23:59:59Z');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return expirationDate < today;
  };

  const handleSendQuestion = (question) => {
    console.log("ID da questão enviada:", question.id); // Adicione esta linha
    setSelectedQuestionId(question.id);
    setShowSimulador(true);
  };

  const closeSimuladorModal = () => {
    setShowSimulador(false);
  };

  const ConfirmationModal = ({ isVisible, onConfirm, onCancel }) => {
    if (!isVisible) return null;

    return (
      <div className="confirmation-modal">
        <div className="modal-content">
          <p>Confirme a exclusão da questão.</p>
          <button className="confirm" onClick={onConfirm}>Confirmar</button>
          <button className="cancel" onClick={onCancel}>Cancelar</button>
        </div>
      </div>
    );
  };

  return (
    <div className="questao-list-container">
      {error && <div className="error-message">{error}</div>}
  
      <ConfirmationModal
        isVisible={showConfirmModal}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
  
      <Modal
        isOpen={showSimulador}
        onRequestClose={closeSimuladorModal}
        contentLabel="Simulador"
        className="simulador-modal"
        overlayClassName="simulador-overlay"
        style={{
          content: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '1000',
            backgroundColor: '#f8f9fa',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            maxWidth: '400px',
            width: '90%',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <Simulador onCancel={closeSimuladorModal}
        specificQuestionId={selectedQuestionId}
        />
      </Modal>
  
      <div className="filter-container">
        <FiltroCurso minicursos={minicursos} valor={selectedCurso} onChange={setSelectedCurso} />
        <label htmlFor="tema-filter">Filtrar por tema:</label>
        <select
          id="tema-filter"
          value={selectedTema}
          onChange={(e) => setSelectedTema(e.target.value)}
          aria-label="Selecionar tema para filtro"
        >
          <option value="">Todos os temas</option>
          {Object.entries(temasMap).map(([id, nome]) => (
            <option key={id} value={id}>
              {nome}
            </option>
          ))}
        </select>
        
        {/* ================================================================= */}
        {/* *** NOVO CHECKBOX DE FILTRO PARA PESQUISAS *** */}
        {/* ================================================================= */}
        <div className="filter-checkbox">
            <input
              type="checkbox"
              id="pesquisas-filter"
              checked={showPesquisas}
              onChange={(e) => setShowPesquisas(e.target.checked)}
            />
            <label htmlFor="pesquisas-filter">Mostrar somente Pesquisas</label>
        </div>

        {questoes.some((questao) => questao.bloqueado) && (
          <div className="filter-checkbox">
            <input
              type="checkbox"
              id="bloqueadas-filter"
              checked={showBloqueadas}
              onChange={(e) => setShowBloqueadas(e.target.checked)}
            />
            <label htmlFor="bloqueadas-filter">Mostrar Bloqueadas</label>
          </div>
        )}

        {selectedCurso || selectedTema || showBloqueadas || showPesquisas ? (
          <button
            className="clear-filter-button"
            onClick={() => {
              setSelectedCurso('');
              setSelectedTema('');
              setShowBloqueadas(false);
              setShowPesquisas(false); // Limpa o novo filtro também
            }}
          >
            Limpar Filtros
          </button>
        ) : null}
      </div>
  
      <div className="table-container">
        <table className="questao-table">
          <thead>
            <tr>
              <th onClick={() => requestSort('enunciado')}>
                Pergunta
                <span className={getSortIcon('enunciado')}></span>
              </th>
              <th onClick={() => requestSort('temas')}>
                Tema(s)
                <span className={getSortIcon('temas')}></span>
              </th>
              <th onClick={() => requestSort('difficulty')}>
                Nível
                <span className={getSortIcon('difficulty')}></span>
              </th>
              <th onClick={() => requestSort('enviado')}>
                Enviada
                <span className={getSortIcon('enviado')}></span>
              </th>
              <th onClick={() => requestSort('createdAt')}>
                Criado
                <span className={getSortIcon('createdAt')}></span>
              </th>
              <th onClick={() => requestSort('dataexpiracao')}>
                Expiração
                <span className={getSortIcon('dataexpiracao')}></span>
              </th>
              <th className="non-clickable">Prioridade</th>
              <th className="non-clickable">Status</th>
              <th className="non-clickable">Ações</th>
            </tr>
          </thead>
          <tbody>
            {questoesDaPagina.length > 0 ? (
              questoesDaPagina.map((questao) => (
                <tr
                  key={questao.id}
                  className={`${isExpired(questao.dataexpiracao) ? 'expired' : ''} ${
                    questao.prioridade > 0 ? 'highlighted' : ''
                  }`}
                  onMouseEnter={(e) => e.currentTarget.classList.add('show-actions')}
                  onMouseLeave={(e) => e.currentTarget.classList.remove('show-actions')}
                >
                  <td>
                    {questao.enunciado}
                    <CursosDoItem vinculos={etapasPorConteudo[questao.id]} cursoSelecionado={selectedCurso} />
                  </td>
                  <td>
                    {questao.temas && questao.temas.length > 0
                      ? questao.temas.map((temaId) => temasMap[temaId] || 'Tema desconhecido').join(', ')
                      : '-'}
                  </td>
                  <td>{questao.difficulty}</td>
                  <td>{questao.enviado ? 'Sim' : 'Não'}</td>
                  <td>{formatDate(questao.createdAt)}</td>
                  <td className={isExpired(questao.dataexpiracao) ? 'expired-date' : ''}>
                    {formatDate(questao.dataexpiracao)}
                  </td>
                  <td className="priority-cell">
  {!questao.bloqueado && (
    <div className="priority-cell">
      {questao.prioridade > 0 ? (
        <>
          <IoIosArrowRoundUp
            size="24"
            className={`arrow-icon ${questao.prioridade === 1 ? 'disabled' : ''}`}
            onClick={() => handleMovePriorityUp(questao)}
            title="Mover prioridade para cima"
          />
          <FaStar
            size="28"
            className="priority-icon active"
            onClick={() => handleTogglePriority(questao)}
            title="Remover prioridade"
          />
          <IoIosArrowRoundDown
            size="24"
            className={`arrow-icon ${questao.prioridade === maxPriority ? 'disabled' : ''}`}
            onClick={() => handleMovePriorityDown(questao)}
            title="Mover prioridade para baixo"
          />
        </>
      ) : (
        <FaRegStar
          size="28"
          className="priority-icon"
          onClick={() => handleTogglePriority(questao)}
          title="Marcar como prioritária"
        />
      )}
    </div>
  )}
</td>

                  <td className="status-cell">
                    {questao.bloqueado ? (
                      <FaCircle
                        size="32"
                        className="action-icon play-icon"
                        onClick={() => handleToggleBloqueado(questao.id, questao.bloqueado, questao.dataexpiracao)}
                        title="Desbloquear"
                      />
                    ) : (
                      <FaCircle
                        size="32"
                        className="action-icon pause-icon"
                        onClick={() => handleToggleBloqueado(questao.id, questao.bloqueado)}
                        title="Bloquear"
                      />
                    )}
                  </td>
                  <td className="actions-cell">
                    <div className="questao-actions">
                      <MdEditNote
                        size="32"
                        className="action-icon edit-icon"
                        onClick={() => onEdit(questao)}
                        title="Editar"
                      />
                      <MdDeleteForever
                        size="32"
                        className="action-icon delete-icon"
                        onClick={() => handleDeleteClick(questao.id)}
                        title="Excluir"
                      />
                      {!questao.bloqueado && (
                        <BsFillRocketTakeoffFill
                          size="32"
                          className="action-icon-resend"
                          onClick={() => handleSendQuestion(questao)}                          
                          title="Envio Expresso"
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9">Nenhuma questão encontrada</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {totalPaginas > 1 && (
        <div className="pagination">
          <button onClick={() => setPagina(pagina - 1)} disabled={pagina === 1}>Anterior</button>
          <span>Página {pagina} de {totalPaginas} · {sortedQuestoes.length} questões</span>
          <button onClick={() => setPagina(pagina + 1)} disabled={pagina === totalPaginas}>Próxima</button>
        </div>
      )}
    </div>
  );
}

export default QuestaoList;
